import { Component, Input } from '@angular/core';
import { CareerPlanPositionType } from 'src/app/models/career-plans';

@Component({
  selector: 'app-career-plan-position',
  templateUrl: './career-plan-position.component.html',
  styleUrls: ['./career-plan-position.component.scss'],
})
export class CareerPlanPositionComponent {
  @Input()
  positionType: CareerPlanPositionType = 'ACTUAL';

  @Input()
  positionName: string;
}
